<script>
import AdminLayout from '@layouts/admin-main'
import FinanceNav from '@components/admin/finance-nav'
import FinanceReturnList from '@components/admin/finance-return-list'

export default {
  page: {
    title: 'Admin::FinanceReturnList',
    meta: [{ name: 'description', content: 'Admin::FinanceReturnList' }],
  },
  components: {
    AdminLayout,
    FinanceNav,
    FinanceReturnList,
  },
}
</script>

<template>
  <AdminLayout>
    <FinanceNav></FinanceNav>
    <FinanceReturnList></FinanceReturnList>
  </AdminLayout>
</template>
